/**
 * 画面の印（SVG）。全て定数（本人の文・LLM の文は入れない）。色は CSS の変数で付ける（currentColor / クラス）。
 */

function svg(markup: string): SVGElement {
  const t = document.createElement("template");
  t.innerHTML = markup.trim();
  return t.content.firstElementChild as SVGElement;
}

/** 見出しの環（ゆっくり回る点線・内側の環・息をする芯）。状態の色はクラス .amber で変える */
export const ringIcon = () =>
  svg(`<svg class="jv-logo" aria-hidden="true" width="34" height="34" viewBox="0 0 34 34" style="overflow:visible">
  <g class="jv-ring"><circle cx="17" cy="17" r="15" fill="none" stroke="var(--ring-dash)" stroke-width="1" stroke-dasharray="6 5" opacity=".75"/></g>
  <circle cx="17" cy="17" r="9.5" fill="none" stroke="var(--ring-inner)" stroke-width="1.2" opacity=".9"/>
  <circle class="jv-core" cx="17" cy="17" r="4.5" fill="var(--ring-core)"/>
</svg>`);

export const calendarIcon = () =>
  svg(
    `<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>`,
  );

export const micIcon = () =>
  svg(
    `<svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>`,
  );

export const sendIcon = () =>
  svg(
    `<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h14M13 6l6 6-6 6"/></svg>`,
  );

export const warnIcon = () =>
  svg(
    `<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l9 16H3z"/><path d="M12 10v4M12 17v.5"/></svg>`,
  );

export const shieldIcon = () =>
  svg(
    `<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/></svg>`,
  );

export const stopIcon = () =>
  svg(
    `<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="5" width="14" height="14" rx="2"/></svg>`,
  );
